export default __webpack_public_path__ + "static/media/Line 518.b43644d3.svg";